<h1 mat-dialog-title>Téléchargez de documents</h1>
<div mat-dialog-content>
  <p>Choisir les documents à télécharger</p>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <ng-container formArrayName="documentsForm">
      @for (doc of documentsForm.controls; track doc; let index = $index) {
        <div class="doc-container">
          @if (index == 0) {
            <div class="row">
              <div class="col col-md-6 text-align-end"></div>
              <div class="col col-md-6 d-flex padding-left-6">
                <!-- <pr-icon name="fingerprint" class="info__icon"></pr-icon> -->
                <span class="file">
                  <img src="assets/svg/ressources/file.svg" />
                </span>
                <!-- <pr-icon name="edit_document" class="info__icon"></pr-icon> -->
                <pr-icon name="visibility_off" class="info__icon"></pr-icon>
              </div>
            </div>
          }
          <div class="row d-flex align-items-baseline">
            <div class="col col-md-6 text-align-end">
              <span>{{ doc.get('name')?.value }}</span>
            </div>
            <div class="col col-md-6">
              <ng-container [formGroup]="doc">
                <pr-checkbox-group
                  formControlName="check"
                  [options]="optionsLabel"
                  [asToggle]="true"
                >
                </pr-checkbox-group>
              </ng-container>
            </div>
          </div>
        </div>
      }
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <pr-button
    style="margin-left: auto"
    size="lg"
    type="submit"
    display="neutral"
    label="Téléchargez !"
    (onClick)="onSubmit()"
  ></pr-button>
  <!-- <form-footer
  (prev)="prev()"
  (next)="onSubmit()"
  [nextLabel]="'Envoyer'"
></form-footer> -->
  <!-- <button mat-button (click)="onNoClick()">No Thanks</button>
<button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>
  Ok
</button> -->
</div>
